import React from 'react';
import VideoLoop from '../VideoLoop'
import styled from 'styled-components'
const VidThirds = styled.div`
    .vid-23 {
        grid-area: vid-23;
    }
    .vid-13{
        grid-area: vid-13;
    }

    .vid-23-grid {
        display: grid;
        column-gap: 1rem;
        grid-template-columns: [vid-23] 4fr [spacer] 1fr [vid-13] 7fr;
        &.reverse {
            direction: rtl;
        }
    }
`
const VideoLoop23VideoLoop13 = ({vidSrc13, vidDesc13, vidSrc23, vidDesc23, reverse}) => {
  return (
      <VidThirds className="row-component">
          <div className={reverse ? `vid-23-grid reverse` : `vid-23-grid`}>
                <div className="vid-23">
                    <VideoLoop src={vidSrc23} description={vidDesc23} />
                </div>
                <div className="vid-13">
                    <VideoLoop src={vidSrc13} description={vidDesc13} />
                </div>
            </div>
      </VidThirds>
  );
};

export default VideoLoop23VideoLoop13;
